@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.modal {
  padding: 0;
  max-width: 656px;
  width: calc(100% - 30px);
}

.content {
  padding: 24px;
}

.title {
  text-align: center;
  color: v.$palette-gray-900;
}

.text {
  @include t.text(14px, 22px, 400);
  text-align: center;
  color: v.$palette-gray-800;
  margin: 24px 0;
}

.btn, .link {
  padding: 11px 24px;
  background-color: v.$palette-blue;
  text-decoration: none;
  box-shadow: v.$shadow-1;
  @include c.containerMedia(520px) {
    width: 100%;
  }
  &, &:hover, &:active, &:focus {
    color: v.$palette-pure-white;
  }

  &.Sea {
    background-color: v.$palette-blue-raw;
  }

  &.Air {
    background-color: v.$palette-air-tracking;
  }
}

.title, .btn, .link {
  @include t.text(20px, 30px, 600);
}
